// Renders a tool's configUI spec (json-render) over its configSchema
// (JSON Schema). Values conform to the schema and are persisted to
// ToolServers/{toolsetId}.values in Firestore.
//
// Catalog (fixed, client-side) lives in ./configCatalog.js.
// Tool-author documentation lives in Common/ToolConfigCatalog.md.

import React from 'react'
import { Renderer, JSONUIProvider } from '@json-render/react'
import { registry, FormProvider } from './configCatalog.js'
import { setAtPath } from './schema.js'

class ToolConfigForm extends React.Component {
  constructor (props) {
    super(props)
    this.state = { values: null, loading: true, loadError: null }
  }

  async componentDidMount () {
    const { me, toolsetId } = this.props
    try {
      const values = await me.loadToolConfigValues(toolsetId)
      this.setState({ values: values || {}, loading: false })
    } catch (err) {
      console.error('loadToolConfigValues failed', err)
      this.setState({ values: {}, loading: false, loadError: err.message })
    }
  }

  setValue = (path, value) => {
    this.setState(s => ({ values: setAtPath(s.values, path, value) }))
  }

  save = async () => {
    const { me, toolsetId } = this.props
    await me.saveToolConfigValues(toolsetId, this.state.values || {})
  }

  render () {
    const { toolConfig, toolsetName } = this.props
    const { values, loading, loadError } = this.state

    if (!toolConfig || !toolConfig.configUI || !toolConfig.configSchema) {
      return null
    }
    if (loading) return <div style={{ padding: '1rem' }}>Loading…</div>

    const ctx = {
      values: values || {},
      schema: toolConfig.configSchema,
      setValue: this.setValue,
      save: this.save,
    }

    return (
      <div style={{ padding: '1rem' }}>
        <h2 style={{ marginBottom: '1rem' }}>Configure {toolsetName}</h2>
        {loadError && (
          <div style={{ color: '#c00', marginBottom: '.5rem' }}>
            Could not load saved values: {loadError}
          </div>
        )}
        <FormProvider value={ctx}>
          <JSONUIProvider registry={registry} initialState={{}}>
            <Renderer spec={toolConfig.configUI} registry={registry} />
          </JSONUIProvider>
        </FormProvider>
      </div>
    )
  }
}

export { ToolConfigForm }
